import React, { Component } from "react";

class Loader extends Component {
  render() {
    return (
      <div
        className={
          this.props.colorClass
            ? this.props.colorClass + "spinner-grow"
            : "spinner-grow th-primary"
        }
        style={{ height: 16, width: 16 }}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}

export default Loader;
